import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonIcon from '@/components/basic/ButtonIcon/ButtonIcon';
import type {
    Realm as RealmFields,
    Zone as ZoneFields,
    Matrix as MatrixFields,
} from '@/generated/graphql';
import { useFoyerConfigDispatch } from '../FoyerProvider';
import Photo from '@/components/media/Photo/Photo';

type NavAreaName = 'realm' | 'zone' | 'matrix';

type NavItemProps = {
    navAreaName: NavAreaName;
    item: RealmFields | ZoneFields | MatrixFields;
    path: string;
    className?: string;
};

const NavItem: FC<NavItemProps> = ({ navAreaName, item, path, className }) => {
    const foyerConfigDispatch = useFoyerConfigDispatch();
    const navigate = useNavigate();

    const goNextNavAreas = () => {
        foyerConfigDispatch({
            type: 'GO_NEXT_NAV_AREAS',
            areaName: navAreaName === 'realm' ? 'zones' : 'matrices',
            id: item.id,
        });
    };
    const goMatrix = () => {
        foyerConfigDispatch({ type: 'TOGGLE_NAV' });
        navigate(path);
    };

    return (
        <div
            className={`Nav_item ${className ? ` ${className}` : ''}`}
            onClick={navAreaName !== 'matrix' ? goNextNavAreas : goMatrix}
            role="button"
            tabIndex={0}
        >
            <section className={`Nav_itemBlock ${navAreaName}`}>
                <div className={`Nav_details ${navAreaName}`}>
                    <h2 className="Nav_title">{item.title}</h2>
                    <Photo
                        className="Nav_bannerPhoto"
                        fields={item.bannerPhoto[0]}
                        imageSize="s"
                    />
                    <p className="Nav_bannerText">{item.bannerText}</p>
                </div>
                <ButtonIcon
                    icon="chevron"
                    label={`${item.title} auswählen`}
                    className={`Nav_next ${navAreaName}`}
                />
            </section>
        </div>
    );
};

export default NavItem;
